import './libraries/slimmageSettings';
import './libraries/slimmage';

import 'promise-polyfill/src/polyfill';

// App
// import App from './app';
import App from './app';
import PolyfillController from './controllers/polyfill';
import SiteController from './site';

// Controllers
// import RibbonController from './controllers/ribbon';
// import StickyCTAController from './controllers/stickycta';
import HeaderController from './controllers/header';
import ConsentController from '@neworange-agency-db/consent-controller';


(async () => {
    document.querySelector('html').classList.remove('no-js');

    const polyfills = new PolyfillController();
    await polyfills.init();

    try {
        const app = new App();
        app.resizeThrottle = 10;
        app.scrollThrottle = 100;
        window.app = app;

        app.polyfillController = polyfills;
        if (SiteController) {
            app.siteController = new SiteController();
        }
        // app.api = new Api();
        app.headerController = new HeaderController();
        app.ConsentController = new ConsentController();

        // Modules
        const loadModules = () => {
            // if (app.getParameter('debugger')) {
            //     import( /* webpackChunkName: "modules/console" */ './controllers/debugger').then(e => {
            //         app.debuggerController = new e.default();
            //     });
            // }

            if (document.querySelector(`video.videoElement`)) {
                import(
                    /* webpackChunkName: "modules/media" */ `./controllers/media`
                ).then((e) => {
                    app.mediaController = new e.default();
                });
            }

            if (document.querySelector(`main form`)) {
                import(
                    /* webpackChunkName: "modules/form" */ `./controllers/form`
                ).then((e) => {
                    app.formController = new e.default();
                });
            }

            if (document.querySelector(`.searchForm`)) {
                import(
                    /* webpackChunkName: "modules/search" */ `./controllers/search`
                ).then((e) => {
                    app.searchController = new e.default();
                });
            }

            if (document.querySelector(`#ribbon`)) {
                import(
                    /* webpackChunkName: "modules/ribbon" */ `./controllers/ribbon`
                ).then((e) => {
                    app.ribbonController = new e.default();
                });
            }

            if (document.querySelector(`[data-tabs]`)) {
                import(
                    /* webpackChunkName: "modules/tabs" */ `./controllers/tabs`
                ).then((e) => {
                    app.tabsController = new e.default();
                });
            }

            if (document.querySelector(`[data-scroll-tabs]`)) {
                import(
                    /* webpackChunkName: "modules/scrollTabs" */ `./controllers/scrollTabs`
                ).then((e) => {
                    app.scrollTabsController = new e.default();
                });
            }

            if (document.querySelector(`[data-slider]`)) {
                import(
                    /* webpackChunkName: "modules/slider" */ `./controllers/slider`
                ).then((e) => {
                    app.sliderController = new e.default();
                });
            }

        };

        loadModules();
        await app.init();
        // app.insertTesters();
    } catch (e) {
        console.error(`Something went wrong initializing the app`);
        throw e;
    }

    console.log(`App initialized`);
    document.documentElement.classList.remove('preventAnimations');
})();
